export interface IStepBar {
	DISPLAY_HORIZONTAL_MEDIA_WIDTH: number;
}

export default interface IStyles {
	STEP_PROGRES_BAR?: IStepBar;
}

class Styles implements IStyles {
	constructor() {
		this.STEP_PROGRES_BAR = {
			DISPLAY_HORIZONTAL_MEDIA_WIDTH: window.STYLES?.STEP_PROGRES_BAR?.DISPLAY_HORIZONTAL_MEDIA_WIDTH ?? 1025,
		};
	}

	STEP_PROGRES_BAR: IStepBar;
}

const AppStyles: Styles = new Styles();

export { AppStyles };
